module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_18.e2422fb8.jpg";